import { createReducer, on } from '@ngrx/store';

import { Package } from '../../models/package.class';
import * as PackageActions from '../actions/packages.actions';
import * as sessionActions from '../actions/session.actions';
import { PackagesState } from '../states/packages.state';

export const PACKAGES_REDUCER_KEY = 'packages';

export const initialPackagesState: PackagesState = {
    currentOrganizationId: '',
    selectedPackageIds: [],
    organizations: {
        ids: [],
        entities: {},
    },
    searchText: undefined,
};

export const PACKAGES_REDUCER = createReducer(
    initialPackagesState,

    on(sessionActions.SetCurrentOrganization, (state, action) => {
        return {
            ...state,
            currentOrganizationId: action.organization?.id,
        };
    }),

    on(PackageActions.SetPackages, (state, { organizationId, packages }) => {
        const newEntities = packages.reduce((acc, pkg) => {
            acc[pkg.id] = pkg;
            return acc;
        }, {} as { [id: string]: Package });

        return {
            ...state,
            organizations: {
                ...state.organizations,
                ids: [...new Set([...state.organizations.ids, organizationId])],
                entities: {
                    ...state.organizations.entities,
                    [organizationId]: {
                        id: organizationId,
                        packages: {
                            ids: packages.map(pkg => pkg.id),
                            entities: newEntities,
                        },
                    },
                },
            },
        };
    }),

    on(PackageActions.SetPackagesSearchText, (state, action) => {
        return {
            ...state,
            searchText: action.searchText,
        };
    }),

    on(PackageActions.ResetPackagesSearchText, state => {
        return {
            ...state,
            searchText: undefined,
        };
    }),

    on(PackageActions.LoadPackageSuccess, (state, { organizationId, packageData }) => {
        const org = state.organizations.entities[organizationId];
        return {
            ...state,
            organizations: {
                ...state.organizations,
                entities: {
                    ...state.organizations.entities,
                    [organizationId]: {
                        id: organizationId,
                        packages: {
                            ids: [...new Set([...(org?.packages?.ids || []), packageData.id])],
                            entities: {
                                ...(org?.packages?.entities || {}),
                                [packageData.id]: packageData,
                            },
                        },
                    },
                },
            },
        };
    }),

    on(PackageActions.CreatePackageSuccess, (state, { organizationId, packageData }) => {
        const org = state.organizations.entities[organizationId];
        return {
            ...state,
            organizations: {
                ...state.organizations,
                entities: {
                    ...state.organizations.entities,
                    [organizationId]: {
                        id: organizationId,
                        packages: {
                            ids: [...new Set([...(org?.packages?.ids || []), packageData.id])],
                            entities: {
                                ...(org?.packages?.entities || {}),
                                [packageData.id]: packageData,
                            },
                        },
                    },
                },
            },
        };
    }),

    on(PackageActions.DeletePackageSuccess, (state, { organizationId, packageId }) => {
        const org = state.organizations.entities[organizationId];
        if (!org) return state;

        const remainingEntities = { ...org.packages.entities };
        delete remainingEntities[packageId];

        return {
            ...state,
            organizations: {
                ...state.organizations,
                entities: {
                    ...state.organizations.entities,
                    [organizationId]: {
                        id: organizationId,
                        packages: {
                            ids: org.packages.ids.filter(id => id !== packageId),
                            entities: remainingEntities,
                        },
                    },
                },
            },
        };
    })
);
